module.exports = __webpack_public_path__ + "static/media/5.bc30580e.png";